// extracted by mini-css-extract-plugin
export default {"main":"_95fd91dab8","tit":"_4ab4ede7a9","maintitle":"_0f528b4314","ylw":"_0fdd801efa","white":"c762e71204","mv_title":"_4e5cdb9b25","mv_nc":"_06cb7bf0df","mv_in":"_9a40c83562"};